import { Component, ElementRef, EventEmitter, HostListener, Output } from "@angular/core";

@Component({
    selector: "menu",
    imports: [],
    templateUrl: "./menu.html",
    styleUrl: "./menu.scss"
})
export class Menu {
    @Output() public readonly closeMenu = new EventEmitter<void>();

    constructor(private readonly el: ElementRef<HTMLElement>) {}

    private getMenuItems(): HTMLElement[] {
        return Array.from(this.el.nativeElement.querySelectorAll<HTMLElement>('[role="menuitem"]:not([disabled])'));
    }

    @HostListener("keydown", ["$event"])
    public onKeydown(event: KeyboardEvent): void {
        const items = this.getMenuItems();
        if (!items.length) return;

        const idx = items.indexOf(document.activeElement as HTMLElement);

        switch (event.key) {
            case "ArrowDown":
                event.preventDefault();
                items[(idx + 1) % items.length]?.focus();
                break;
            case "ArrowUp":
                event.preventDefault();
                items[(idx - 1 + items.length) % items.length]?.focus();
                break;
            case "Home":
                event.preventDefault();
                items[0]?.focus();
                break;
            case "End":
                event.preventDefault();
                items[items.length - 1]?.focus();
                break;
            case "Escape":
                event.preventDefault();
                this.closeMenu.emit();
                break;
        }
    }
}
